import { CheckCircleOutlined, ErrorOutlined, InfoOutlined, WarningOutlined } from '@mui/icons-material'
import { Box, useTheme } from '@mui/material'

import useStyles from './index.styles'

const AlertSeverityIcon = ({ severity, response, isOffline }: { severity: string; response: string; isOffline: boolean }) => {
  const theme = useTheme()
  const classes = useStyles

  const offlineText = isOffline ? ' (Offline)' : ''

  const type = response ? 'responded' : severity

  const { IconComponent, iconColor, ariaLabel } = {
    responded: { IconComponent: CheckCircleOutlined, iconColor: theme.palette.info.main, ariaLabel: response },
    info: { IconComponent: InfoOutlined, iconColor: theme.palette.info.main, ariaLabel: 'Info alert' },
    warning: { IconComponent: WarningOutlined, iconColor: theme.palette.warning.light, ariaLabel: 'Warning alert' },
    urgent: { IconComponent: ErrorOutlined, iconColor: theme.palette.error.main, ariaLabel: 'Urgent alert' },
  }[type] ?? { IconComponent: CheckCircleOutlined, iconColor: theme.palette.info.main, ariaLabel: 'Unknown' }

  if (ariaLabel === 'Unknown') return null
  return (
    <Box sx={classes.alertIcon}>
      <IconComponent fontSize="small" htmlColor={isOffline ? theme.palette.divider : iconColor} aria-label={`${ariaLabel}${offlineText}`} />
    </Box>
  )
}

export default AlertSeverityIcon
